import React from 'react';

//Componentes
import TableContainer from '../table/TableContainer';

//Estilos
import './GuiaLogs.css';

function GuiaLogs({ tableData }) {
    return (
        <div className="guia_logs-container">
            {tableData.data.length > 0 ? (
                <TableContainer tableData={tableData} />
            ) : (
                <h4>No hay logs para esta guía</h4>
            )}
        </div>
    );
}

export default GuiaLogs;
